module.exports = __webpack_public_path__ + "img/CR.b12a0aaa.png";